import PersonacionFormView from 'src/components/views/EscritosLexnet/components/Personacion/PersonacionFormView'
import SubmitForm from 'src/components/views/EscritosLexnet/components/shared/components/SubmitForm'

type PersonacionPropsType = {
  section: string
}

function Personacion({ section }: PersonacionPropsType): JSX.Element {
  return (
    <SubmitForm>
      <PersonacionFormView section={section} />
    </SubmitForm>
  )
}

export default Personacion
